<template>
  <div ref="item" class="expandable-text">
    <div ref="content" class="content">
     <slot></slot>
    </div>
    <div ref="fadeout" v-show="!expanded && this.overflown" class="fadeout" :class="[`background-${gradientColor}`]"></div>
    <div v-show="this.overflown && !expanded" @click="expand()" class="show-button" :class="[labelColor, labelSize, `background-${gradientColor}`]">
        {{expandLabel}}
    </div>
    <div v-show="expanded && collapsible" @click="showLess()" class="show-button" :class="[labelColor, labelSize]">
        {{collapseLabel}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'expandable-text',
  props: {
    expandLabel: {
      type: String,
      default: 'Show More'
    },
    collapseLabel: {
      type: String,
      default: 'Show Less'
    },
    contentDisplay: {
      type: String,
      default: 'md'
    },
    collapsible: {
      type: Boolean,
      default: true
    },
    labelColor: {
      type: String
    },
    labelSize: {
      type: String
    },
    gradientColor: {
      type: String
    }
  },
  data() {
    return {
      expanded: false,
      overflown: false,
      overflowHeight: 0
    }
  },
  methods: {
    expand() {
      this.expanded = true
      this.$refs.content.style.height = 'auto'
    },
    showLess() {
      this.$refs.content.style.height = `${this.overflowHeight}px`
      this.expanded = false
      this.onResize()
    },
    onResize() {
      if (this.$refs.content && this.isOverflown(this.$refs.content) && !this.expanded) {
        this.overflown = true
        this.$refs.content.style.height = `${this.overflowHeight}px`
        this.$refs.fadeout.style.height = `${this.overflowHeight}px`
        this.$refs.fadeout.style.width = `${this.$refs.content.clientWidth}px`
      } else {
        this.overflown = false
      }
    },
    isOverflown(element) {
      return (element.scrollHeight > element.clientHeight) && (element.scrollHeight > this.overflowHeight)
    }
  },
  mounted() {
    switch (this.contentDisplay) {
      case 'sm':
        this.overflowHeight = 100
        break
      case 'md':
        this.overflowHeight = 300
        break
      case 'lg':
        this.overflowHeight = 500
        break
      default:
        this.overflowHeight = 100
        break
    }
    this.$refs.content.style.height = `${this.overflowHeight}px`
    window.addEventListener('resize', this.onResize)
    setTimeout(() => {
      this.onResize()
    }, 50)
  }
}
</script>